<template>
  <div class="container-fluid">
    <div v-if="state.isAuthenticated" class="row">
      <TopNav v-if="showTopNav" />
      <Sidebar v-if="!showTopNav" />

      <router-view v-if="userStore.userInfo" />

      <div v-if="isLoading" class="col-md-10 text-center">
        <div class="spinner-border mt-3" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- </main> -->
    </div>
    <div v-else>
      <div class="p-5">
        <svg
          height="25"
          viewBox="0 0 249 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_2435_10198"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="249"
            height="60"
          >
            <path d="M248.719 0H0.439453V59.1H248.719V0Z" fill="white"></path>
          </mask>
          <g mask="url(#mask0_2435_10198)">
            <path
              d="M20.6897 36.3H10.3597V50.76H21.0197C27.7197 50.76 31.0797 48.32 31.0797 43.43C31.0797 40.93 30.2097 39.12 28.4697 37.99C26.7297 36.86 24.1397 36.3 20.6897 36.3ZM10.3597 16.48V29.19H19.4497C21.9197 29.19 23.8297 28.96 25.1797 28.49C26.5297 28.02 27.5597 27.13 28.2697 25.81C28.8197 24.87 29.0997 23.82 29.0997 22.66C29.0997 20.18 28.2197 18.53 26.4597 17.71C24.6997 16.89 22.0197 16.48 18.4097 16.48H10.3597ZM21.4197 58.23H6.44969C4.28969 58.23 2.74969 57.74 1.81969 56.77C0.899687 55.8 0.429688 54.25 0.429688 52.12V15.12C0.429688 12.95 0.899687 11.39 1.84969 10.44C2.79969 9.49001 4.32969 9.01001 6.44969 9.01001H22.3197C24.6597 9.01001 26.6797 9.16001 28.3997 9.45001C30.1097 9.74001 31.6497 10.3 33.0097 11.13C34.1697 11.82 35.1897 12.7 36.0797 13.76C36.9697 14.82 37.6497 15.99 38.1097 17.28C38.5797 18.56 38.8097 19.92 38.8097 21.35C38.8097 26.26 36.3597 29.86 31.4697 32.14C37.8997 34.2 41.1197 38.22 41.1197 44.19C41.1197 46.95 40.4197 49.43 39.0197 51.64C37.6197 53.85 35.7297 55.48 33.3497 56.53C31.8597 57.16 30.1397 57.6 28.1997 57.85C26.2597 58.11 23.9997 58.24 21.4197 58.24"
              fill="#3D2C24"
            ></path>
            <path
              d="M56.0698 27.0501V53.5401C56.0698 55.3801 55.6398 56.7601 54.7798 57.7001C53.9198 58.6401 52.8198 59.1101 51.4998 59.1101C50.1798 59.1101 49.0998 58.6301 48.2698 57.6701C47.4398 56.7101 47.0298 55.3301 47.0298 53.5401V27.3201C47.0298 25.5101 47.4398 24.1501 48.2698 23.2301C49.0998 22.3101 50.1798 21.8501 51.4998 21.8501C52.8198 21.8501 53.9198 22.3101 54.7798 23.2301C55.6398 24.1501 56.0698 25.4201 56.0698 27.0601"
              fill="#3D2C24"
            ></path>
            <path
              d="M88.5698 40.4901C88.5698 36.7701 87.7498 33.8801 86.0998 31.8001C84.4498 29.7301 82.2398 28.6901 79.4598 28.6901C77.6698 28.6901 76.0898 29.1501 74.7198 30.0801C73.3498 31.0101 72.2998 32.3701 71.5598 34.1701C70.8198 35.9701 70.4498 38.0801 70.4498 40.4901C70.4498 42.9001 70.8098 44.9601 71.5398 46.7401C72.2698 48.5201 73.3098 49.8901 74.6598 50.8301C76.0098 51.7801 77.6098 52.2501 79.4498 52.2501C82.2298 52.2501 84.4398 51.2101 86.0898 49.1301C87.7398 47.0501 88.5598 44.1701 88.5598 40.4901M97.7398 40.4901C97.7398 43.2201 97.3098 45.7301 96.4598 48.0401C95.6098 50.3401 94.3798 52.3201 92.7698 53.9801C91.1598 55.6401 89.2398 56.9001 86.9998 57.7901C84.7598 58.6701 82.2498 59.1101 79.4498 59.1101C76.6498 59.1101 74.1798 58.6601 71.9698 57.7701C69.7498 56.8701 67.8298 55.5901 66.2098 53.9301C64.5898 52.2601 63.3598 50.2901 62.5198 48.0201C61.6798 45.7501 61.2598 43.2401 61.2598 40.4801C61.2598 37.7201 61.6798 35.1701 62.5398 32.8601C63.3898 30.5501 64.6098 28.5901 66.1998 26.9501C67.7898 25.3201 69.7098 24.0601 71.9698 23.1701C74.2298 22.2901 76.7198 21.8401 79.4498 21.8401C82.1798 21.8401 84.7398 22.2901 86.9998 23.1801C89.2598 24.0801 91.1898 25.3501 92.7998 27.0101C94.4098 28.6701 95.6398 30.6401 96.4698 32.9201C97.3098 35.2101 97.7298 37.7301 97.7298 40.4801"
              fill="#3D2C24"
            ></path>
            <path
              d="M148.9 38.2699V47.6899C148.9 48.9399 148.78 49.9399 148.53 50.6899C148.29 51.4399 147.84 52.1099 147.18 52.7199C146.53 53.3199 145.69 53.9099 144.67 54.4599C141.7 56.0699 138.85 57.2499 136.11 57.9899C133.37 58.7299 130.38 59.0999 127.15 59.0999C123.38 59.0999 119.95 58.5199 116.85 57.3499C113.75 56.1899 111.11 54.4899 108.93 52.2699C106.75 50.0499 105.07 47.3599 103.9 44.1999C102.73 41.0399 102.14 37.5099 102.14 33.6099C102.14 29.7099 102.71 26.2699 103.84 23.0899C104.98 19.9099 106.65 17.2099 108.86 14.9899C111.07 12.7699 113.75 11.0699 116.92 9.89988C120.08 8.71988 123.67 8.12988 127.68 8.12988C130.98 8.12988 133.9 8.57988 136.44 9.45988C138.98 10.3499 141.04 11.4699 142.62 12.8199C144.2 14.1699 145.4 15.5999 146.2 17.1099C147 18.6199 147.4 19.9599 147.4 21.1299C147.4 22.3899 146.94 23.4699 146.02 24.3499C145.1 25.2399 143.99 25.6799 142.71 25.6799C142 25.6799 141.32 25.5099 140.66 25.1699C140 24.8299 139.45 24.3499 139.01 23.7399C137.78 21.8099 136.74 20.3499 135.9 19.3599C135.05 18.3699 133.91 17.5399 132.47 16.8699C131.03 16.1999 129.19 15.8599 126.96 15.8599C124.73 15.8599 122.61 16.2599 120.8 17.0499C118.99 17.8399 117.45 18.9999 116.16 20.5099C114.88 22.0199 113.89 23.8799 113.21 26.0699C112.53 28.2699 112.19 30.6999 112.19 33.3599C112.19 39.1399 113.51 43.5899 116.16 46.6999C118.81 49.8099 122.5 51.3699 127.23 51.3699C129.53 51.3699 131.69 51.0699 133.71 50.4599C135.73 49.8599 137.78 48.9999 139.86 47.8799V39.8999H132.16C130.31 39.8999 128.91 39.6199 127.96 39.0599C127.01 38.4999 126.54 37.5499 126.54 36.2099C126.54 35.1199 126.93 34.2099 127.73 33.4899C128.52 32.7699 129.59 32.4199 130.95 32.4199H142.21C143.59 32.4199 144.76 32.5399 145.72 32.7899C146.68 33.0299 147.45 33.5799 148.04 34.4299C148.63 35.2799 148.93 36.5499 148.93 38.2499"
              fill="#3D2C24"
            ></path>
            <path
              d="M178.13 40.66C176.79 41.15 174.85 41.67 172.3 42.21C169.75 42.76 167.99 43.15 167.01 43.41C166.03 43.67 165.09 44.17 164.21 44.91C163.32 45.65 162.87 46.69 162.87 48.02C162.87 49.35 163.39 50.57 164.44 51.54C165.49 52.51 166.85 52.99 168.55 52.99C170.35 52.99 172.02 52.6 173.54 51.81C175.06 51.02 176.18 50.01 176.9 48.76C177.72 47.38 178.13 45.12 178.13 41.96V40.66ZM178.73 53.85C176.52 55.6 174.39 56.92 172.33 57.79C170.27 58.67 167.96 59.1 165.39 59.1C163.05 59.1 160.99 58.63 159.22 57.71C157.45 56.78 156.08 55.52 155.12 53.93C154.16 52.34 153.68 50.62 153.68 48.76C153.68 46.25 154.47 44.12 156.06 42.35C157.65 40.58 159.82 39.39 162.59 38.79C163.17 38.66 164.6 38.36 166.9 37.89C169.19 37.42 171.16 36.99 172.79 36.6C174.43 36.21 176.2 35.74 178.12 35.18C178.01 32.73 177.52 30.94 176.66 29.79C175.8 28.65 174.03 28.07 171.33 28.07C169.01 28.07 167.27 28.4 166.1 29.06C164.93 29.72 163.93 30.7 163.09 32.02C162.25 33.33 161.66 34.2 161.32 34.62C160.98 35.04 160.23 35.25 159.1 35.25C158.07 35.25 157.19 34.92 156.44 34.25C155.69 33.59 155.32 32.74 155.32 31.7C155.32 30.08 155.89 28.51 157.03 26.98C158.17 25.45 159.94 24.19 162.35 23.2C164.76 22.21 167.76 21.72 171.35 21.72C175.37 21.72 178.52 22.2 180.82 23.15C183.12 24.1 184.74 25.61 185.69 27.67C186.64 29.73 187.11 32.46 187.11 35.86C187.11 38.01 187.11 39.84 187.09 41.33C187.08 42.83 187.06 44.5 187.04 46.33C187.04 48.06 187.32 49.86 187.89 51.74C188.46 53.62 188.74 54.82 188.74 55.36C188.74 56.31 188.3 57.16 187.41 57.94C186.53 58.72 185.52 59.1 184.41 59.1C183.47 59.1 182.54 58.65 181.63 57.75C180.71 56.85 179.74 55.55 178.71 53.84"
              fill="#3D2C24"
            ></path>
            <path
              d="M203.37 27.0501V53.5401C203.37 55.3801 202.94 56.7601 202.08 57.7001C201.22 58.6401 200.12 59.1101 198.8 59.1101C197.48 59.1101 196.4 58.6301 195.57 57.6701C194.74 56.7101 194.33 55.3301 194.33 53.5401V27.3201C194.33 25.5101 194.74 24.1501 195.57 23.2301C196.4 22.3101 197.48 21.8501 198.8 21.8501C200.12 21.8501 201.22 22.3101 202.08 23.2301C202.94 24.1501 203.37 25.4201 203.37 27.0601"
              fill="#3D2C24"
            ></path>
            <path
              d="M233.27 40.66C231.93 41.15 229.99 41.67 227.44 42.21C224.89 42.76 223.13 43.15 222.15 43.41C221.17 43.67 220.23 44.17 219.35 44.91C218.46 45.65 218.01 46.69 218.01 48.02C218.01 49.35 218.53 50.57 219.58 51.54C220.63 52.51 221.99 52.99 223.69 52.99C225.49 52.99 227.16 52.6 228.68 51.81C230.2 51.02 231.32 50.01 232.04 48.76C232.86 47.38 233.27 45.12 233.27 41.96V40.66ZM233.87 53.85C231.66 55.6 229.53 56.92 227.47 57.79C225.41 58.67 223.1 59.1 220.53 59.1C218.19 59.1 216.13 58.63 214.36 57.71C212.59 56.78 211.22 55.52 210.26 53.93C209.3 52.34 208.82 50.62 208.82 48.76C208.82 46.25 209.61 44.12 211.2 42.35C212.79 40.58 214.96 39.39 217.73 38.79C218.31 38.66 219.74 38.36 222.04 37.89C224.33 37.42 226.3 36.99 227.93 36.6C229.57 36.21 231.34 35.74 233.26 35.18C233.15 32.73 232.66 30.94 231.81 29.79C230.95 28.65 229.17 28.07 226.48 28.07C224.16 28.07 222.42 28.4 221.25 29.06C220.08 29.72 219.08 30.7 218.24 32.02C217.4 33.33 216.81 34.2 216.47 34.62C216.13 35.04 215.38 35.25 214.25 35.25C213.22 35.25 212.34 34.92 211.59 34.25C210.84 33.59 210.47 32.74 210.47 31.7C210.47 30.08 211.04 28.51 212.18 26.98C213.32 25.45 215.09 24.19 217.5 23.2C219.91 22.21 222.91 21.72 226.5 21.72C230.52 21.72 233.67 22.2 235.97 23.15C238.27 24.1 239.89 25.61 240.84 27.67C241.79 29.73 242.26 32.46 242.26 35.86C242.26 38.01 242.26 39.84 242.24 41.33C242.23 42.83 242.21 44.5 242.19 46.33C242.19 48.06 242.47 49.86 243.04 51.74C243.61 53.62 243.89 54.82 243.89 55.36C243.89 56.31 243.45 57.16 242.56 57.94C241.68 58.72 240.67 59.1 239.56 59.1C238.62 59.1 237.69 58.65 236.78 57.75C235.86 56.85 234.89 55.55 233.86 53.84"
              fill="#3D2C24"
            ></path>
            <path
              d="M198.869 17.86C203.799 17.86 207.799 13.86 207.799 8.93C207.799 4 203.799 0 198.869 0C193.939 0 189.939 4 189.939 8.93C189.939 13.86 193.939 17.86 198.869 17.86Z"
              fill="#3D2C24"
            ></path>
            <path
              d="M51.5496 17.86C56.4796 17.86 60.4796 13.86 60.4796 8.93C60.4796 4 56.4796 0 51.5496 0C46.6196 0 42.6196 4 42.6196 8.93C42.6196 13.86 46.6196 17.86 51.5496 17.86Z"
              fill="#3D2C24"
            ></path>
            <path
              d="M248.189 17.3899C247.839 16.7899 247.349 16.3099 246.739 15.9599C246.129 15.6099 245.449 15.4399 244.709 15.4399C243.969 15.4399 243.299 15.6099 242.689 15.9599C242.079 16.3099 241.599 16.7799 241.239 17.3899C240.889 17.9899 240.709 18.6499 240.709 19.3699C240.709 20.0899 240.889 20.7499 241.239 21.3499C241.589 21.9499 242.079 22.4299 242.689 22.7799C243.299 23.1299 243.979 23.2999 244.709 23.2999C245.439 23.2999 246.129 23.1299 246.739 22.7799C247.349 22.4299 247.839 21.9499 248.189 21.3499C248.539 20.7499 248.719 20.0899 248.719 19.3699C248.719 18.6499 248.539 17.9899 248.189 17.3899ZM247.539 21.0199C247.249 21.5199 246.849 21.9099 246.349 22.1999C245.849 22.4899 245.299 22.6299 244.709 22.6299C244.119 22.6299 243.569 22.4899 243.069 22.1999C242.579 21.9099 242.179 21.5199 241.889 21.0199C241.599 20.5199 241.449 19.9699 241.449 19.3699C241.449 18.7699 241.599 18.2199 241.889 17.7299C242.179 17.2299 242.579 16.8399 243.069 16.5499C243.569 16.2599 244.109 16.1199 244.709 16.1199C245.309 16.1199 245.859 16.2599 246.349 16.5499C246.849 16.8399 247.239 17.2299 247.539 17.7299C247.829 18.2299 247.979 18.7799 247.979 19.3699C247.979 19.9599 247.829 20.5199 247.539 21.0199ZM246.239 19.3499C246.419 19.1499 246.509 18.8999 246.509 18.6099C246.509 18.2299 246.349 17.9099 246.049 17.6499C245.739 17.3899 245.359 17.2599 244.899 17.2599H243.099V21.5399H243.919V19.9499H244.899L245.819 21.5399H246.699L245.629 19.7699C245.859 19.6899 246.059 19.5499 246.239 19.3499ZM244.899 19.2499H243.919V17.9799H244.899C245.159 17.9799 245.359 18.0399 245.489 18.1499C245.619 18.2599 245.689 18.4199 245.689 18.6199C245.689 18.8199 245.619 18.9699 245.489 19.0799C245.349 19.1899 245.159 19.2499 244.899 19.2499Z"
              fill="#3D2C24"
            ></path>
          </g>
        </svg>

        <br /><br />
        <button
          v-if="!hasCode && !isLoginLoading && !state.isAuthenticated"
          class="btn btn-primary w-25 mt-5"
          @click="handleLogin"
        >
          Login
        </button>

        <div v-if="isLoginLoading" class="col-md-12 text-center">
          <div class="spinner-border mt-3" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { msalService } from "./config/useAuth";
import { msalInstance, state } from "./config/msalConfig";

import { Component, Vue } from "vue-facing-decorator";
import { useRoute } from "vue-router";
import TopNav from "@/components/shared/TopNav.vue";
import Sidebar from "@/components/shared/Sidebar.vue";
import { UserClient, UserInformation, UserRequest } from "@/data/client";
import { useUserStore } from "@/store/userStore";
import { toast } from "vue3-toastify";
import axios, { Axios } from "axios";

@Component({
  components: { TopNav, Sidebar },
})
class App extends Vue {
  route = useRoute();
  state = state;
  userClient!: UserClient;
  userStore = useUserStore();
  isLoading = false;
  isLoginLoading = false;
  hasCode = false;

  async mounted() {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.slice(1));
    this.hasCode = params.get("code") === null ? false : true;

    if (this.hasCode) {
      this.isLoginLoading = true;
    }

    var axiosClient = axios.create();
    await this.initialize(axiosClient);
    await this.handleRedirect();

    this.userClient = new UserClient(
      process.env.VUE_APP_BACKEND_URI ?? "",
      axiosClient
    );

    if (!this.userStore.userInfo) {
      this.getUserInfo();
    }
  }

  async initialize(axiosClient: Axios) {
    try {
      await msalInstance.initialize();
      this.registerAuthorizationHeaderInterceptor(axiosClient);
    } catch (error) {
      console.log("Initialization error", error);
    }
  }

  async handleLogin() {
    this.isLoginLoading = true;
    await this.login();
  }

  login = msalService().login;
  logout = msalService().logout;
  handleRedirect = msalService().handleRedirect;
  registerAuthorizationHeaderInterceptor =
    msalService().registerAuthorizationHeaderInterceptor;

  get showTopNav(): boolean {
    return this.route.path == "/cart";
  }

  getUserInfo() {
    this.isLoading = true;
    state.isAuthenticated = false;
    // console.log("Fetching user information...", this.userStore.accountInfo);
    const userReq = new UserRequest({
      email: this.userStore.accountInfo?.username,
    });

    if (userReq.email !== undefined) {
      this.userClient
        .getUser(userReq)
        .then((user: UserInformation) => {
          this.userStore.userInfo = user;
          this.isLoading = false;
          state.isAuthenticated = true;
        })
        .catch((error: any) => {
          // If no user info is found on account email, try other email if it is not same and empty
          if (
            this.userStore.otherEmail &&
            this.userStore.accountInfo?.username !== this.userStore.otherEmail
          ) {
            userReq.email = this.userStore.otherEmail;

            this.userClient
              .getUser(userReq)
              .then((user: UserInformation) => {
                this.userStore.userInfo = user;
                this.isLoading = false;
                state.isAuthenticated = true;
              })
              .catch((error: any) => {
                console.error("Error fetching user:", error.response);
                toast.error(error.response.errorMessage, {
                  position: "top-center",
                });
                this.isLoading = false;
              });
          } else {
            console.error("Error fetching user:", error.response);
            toast.error(error.response.errorMessage, {
              position: "top-center",
            });
            this.isLoading = false;
          }
        });
    }
  }
}

export default App;
</script>
